import { Controller } from "@hotwired/stimulus"

// Sticky "download our app" banner. Hidden by default; reveals itself unless
// the visitor closed it within the last 30 days (a timestamp in localStorage).
// The old value "1" meant "closed for good"; it now counts as closed today, so
// those visitors see the banner again in 30 days rather than at once.
const STORAGE_KEY = "app_banner_dismissed"
const QUIET_DAYS = 30
const DAY_MS = 24 * 60 * 60 * 1000

export default class extends Controller {
  connect() {
    if (!this.#recentlyDismissed) this.element.classList.remove("hidden")
  }

  dismiss() {
    this.#write(Date.now())
    this.element.remove()
  }

  get #recentlyDismissed() {
    const stored = this.#read()
    if (stored === null) return false
    if (stored === "1") {
      this.#write(Date.now())
      return true
    }

    const dismissedAt = Number(stored)
    return Number.isFinite(dismissedAt) && Date.now() - dismissedAt < QUIET_DAYS * DAY_MS
  }

  // Storage can throw (private mode, blocked site data): then the banner simply shows.
  #read() {
    try { return localStorage.getItem(STORAGE_KEY) } catch { return null }
  }

  #write(value) {
    try { localStorage.setItem(STORAGE_KEY, String(value)) } catch {}
  }
}
